import React from "react";
import "./SheetTabs.css";

/**
 * SheetTabs
 * Bottom tab bar — one button per sheet name.  The active sheet is
 * highlighted; clicking another tab calls `onSelect(name)`.
 */
function SheetTabs({ sheetNames, activeSheet, onSelect }) {
  return (
    <div className="simple-excel-sheetbar">
      <div className="simple-excel-tabs" role="tablist" aria-label="Sheets">
        {sheetNames.map((name) => (
          <button
            key={name}
            type="button"
            className={`simple-excel-tab ${activeSheet === name ? "active" : ""}`}
            onClick={() => onSelect(name)}
            title={name}
          >
            {name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default React.memo(SheetTabs);
